import { getIconBaseOnColumnDataType, getIconBaseOnColumnType, IDataModuleColumn }
  from '../services/interface/iDataModuleColumnService';
import { Column } from './column.model';

export class DataSourceDataModuleColumn implements IDataModuleColumn {
  private column: Column;

  constructor(column: Column) {
    this.column = column;
  }
  getDataColumnIcon(): string {
    return getIconBaseOnColumnType(this.column?.columnType?.toString()) ??
      getIconBaseOnColumnDataType(this.column?.dataType.toString());
  }
}
